import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import "lenis/dist/lenis.css";
import "@/App.css";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App bg-void min-h-screen">
      <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </ReactLenis>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid rgba(255,255,255,0.1)", color: "#FAFAFA" } }} />
    </div>
  );
}

export default App;
